{
  "users": {
    "page": {
      "title": "Admin",
      "subtitle": "Manage who can access OMS and review every change made across the system."
    },
    "toolbar": {
      "invite": "Invite user",
      "search_placeholder": "Search by name or email…",
      "all_roles": "All roles",
      "all_statuses": "All statuses"
    },
    "column": {
      "user": "User",
      "role": "Role",
      "last_signin": "Last sign-in",
      "status": "Status",
      "created": "Created"
    }
  },
  "audit_log": {
    "page": {
      "title": "Audit log"
    },
    "toolbar": {
      "search_placeholder": "Search action, user, resource…",
      "all_domains": "All domains",
      "all_severities": "All severities",
      "all_actors": "All actors",
      "export_csv": "Export CSV"
    },
    "severity": {
      "info": "INFO",
      "notable": "NOTABLE",
      "high": "HIGH"
    }
  }
}
